<template>
  <el-dialog
    :visible.sync="innerVisible"
    @close="innerVisible = false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :width="width"
    v-bind="$attrs"
    class="dialog"
  >
    <slot v-if="!hideTitle" name="title" slot="title">
      <Title>{{ $attrs.title }}</Title>
    </slot>
    <slot></slot>
  </el-dialog>
</template>

<script>
import visibleMixin from "@/mixins/visibleMixin";
import Title from "@/components/Title.vue";

export default {
  name: "Dialog",

  mixins: [visibleMixin],

  components: {
    Title,
  },

  props: {
    loading: Boolean,
    width: {
      type: String,
      default: "980px",
    },
    hideTitle: Boolean,
  },

  computed: {
    innerLoading: {
      get({ loading }) {
        return loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/common.scss";
.dialog {
  &.el-dialog__wrapper {
    /deep/ .el-dialog__header {
      padding: 0;
      .wrapper {
        padding: 0 18px;
        border-radius: $border-radius;
      }
    }
    /deep/ .el-dialog__title {
      font-size: 24px;
      font-weight: 600;
      color: #000000;
    }
    /deep/ .el-dialog__body {
      padding: 30px 60px;
    }
    /deep/ .el-form-item__label {
      font-size: 18px;
    }
    .el-input {
      font-size: 18px;
    }
    .el-date-editor {
      width: 100%;
    }
    .left {
      display: flex;
      align-items: center;
      padding-left: 4px;
      color: $primary-color;
      .file-name {
        @extend .f18;
        margin-right: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        line-height: normal;
        text-align: left;
      }
      .preview-btn {
        &:before {
          margin-right: 2px;
        }
      }
    }
  }
}
</style>